import i18n from '@app/i18n';

export const transformQuestionDependencyParameter = (parameter: string) => {
  switch (parameter) {
    case 'false':
      return i18n.t('common.no');
    case 'true':
      return i18n.t('common.yes');

    default:
      return parameter;
  }
};
